import * as React from 'react'
import { Animated } from 'react-animated-css'

// Import Header styling
import './Header.css'

const Header: React.FunctionComponent = () => {
  return (
    <div className="jumbotron">
      <div className="jumbotron-text">
        <Animated animationIn="fadeInLeft" animationOut="fadeOut" isVisible={true}>
          <h1>Jacob Swan-Mearns</h1>
        </Animated>
        <Animated animationIn="fadeInUp" animationOut="fadeOut" animationInDelay={750} isVisible={true}>
          <p>Full-Stack Web Developer in Brisbane, Qld.</p>
        </Animated>
      </div>
      <Animated animationIn="flipInY" animationOut="flipOutX" animationInDelay={1500} isVisible={true}>
        <div className="jumbotron-social">
          <ul className="ul-social">
            <li className="li-social-links">
              <a className="social" href="https://github.com/sWiZZleee" target="_blank" rel="noopener noreferrer"><i className="fa fa-github" aria-hidden="true"></i></a>
            </li>
            <li className="li-social-links">
              <a className="social" href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin" aria-hidden="true"></i></a>
            </li>
            <li className="li-social-links">
              <a className="social" href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><i className="fa fa-twitter" aria-hidden="true"></i></a>
            </li>
          </ul>
        </div>
      </Animated>
      <Animated animationIn="bounceInUp" animationOut="fadeOut" animationInDelay={3000} isVisible={true}>
        <div id="down-arrow">
          <span><a href="#about"><i className="fa fa-chevron-down" aria-hidden="true"></i></a></span>
        </div>
      </Animated>
    </div>
  )
}

export default Header
